import { mainFetch } from "../mainFetch"

const SERVICE_URL = '/warehouse/reserves'

const fetchService = async ({ url, ...params }) =>
    await mainFetch({ url: SERVICE_URL + url, ...params })
        .catch(e => { console.log(e); throw (e) });

export default class ReservesApi {

    static async createReserve({ data = { market: undefined, timeScheduled: undefined, skladName: undefined }, ...params }) {
        return await fetchService({ url: '/createreserve', method: 'POST', data, ...params })
    }

    static async getAllReserves({ data = { status: undefined, skladName: undefined }, ...params }) {
        return await fetchService({ url: '/getallreserves', method: 'POST', data, notify: { success: false }, ...params })
    }





    static async getReserve({ data = { reserveId: undefined }, ...params }) {
        return await fetchService({ url: '/getreserve', method: 'GET', data, notify: { success: false }, ...params })
    }

    static async getReserves({ data = { tab: undefined, reservesId: undefined, periodFrom: undefined, notCollected: undefined, search: undefined, skladName: undefined, limit: undefined, page: undefined }, ...params }) {
        return await fetchService({ url: '/getreserves', method: 'POST', data, notify: { success: false }, ...params })
    }

    static async addToReserve({ data = { reserveId: undefined, products: undefined }, ...params }) {
        return await fetchService({ url: '/addtoreserve', method: 'POST', data, ...params })
    }

    static async closeReserve({ data = { reserveId: undefined }, ...params }) {
        return await fetchService({ url: '/close', method: 'POST', data, notify: { msg: 'Резервы списаны' }, ...params })
    }

    static async deleteReserve({ data = { reserveId: undefined }, ...params }) {
        return await fetchService({ url: '/deletereserve', method: 'DELETE', data, notify: { msg: 'Резерв удалён' }, ...params })
    }

    static async changeReservedProduct({ data = { reservedProductId: undefined, field: undefined, value: undefined, action: undefined }, ...params }) {
        return await fetchService({ url: '/changereservedproduct', method: 'PATCH', data, ...params })
    }

    static async dereserve({ data = { reservedProductId: undefined, quantity: undefined }, ...params }) {
        return await fetchService({ url: '/dereserve', method: 'PATCH', data, notify: { msg: 'Товар дерезервирован' }, ...params })
    }




    static async excelReserve({ data = { reserveId: undefined }, ...params }) {
        return await fetchService({ url: '/excelreserve', method: 'POST', data, options: { download: true }, ...params })
    }

}